var $image;

$(document).ready(function() {    
    $("#example-images").fineUploader({
        template: 'example-images-template',
        button: $('#btn-file-upload'),
        classes: {
          success: 'well',
          fail: 'well'
        },
        session: {
            endpoint: '/de/ajax/examples/images/index',
            customHeaders: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken
            },
            params: {
                example_id: $('#example_id').val(),
                language: $('#language').val()
            }
        },
        request: {
            endpoint: '/de/ajax/examples/upload',
            customHeaders: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken
            },
            params: {
                example_id: $('#example_id').val(),
                language: $('#language').val()
            }
        },
        validation: {
            allowedExtensions: ['jpeg', 'jpg', 'png'],
            sizeLimit: 8388608,
        },
        messages: {
            typeError: "{file} ist kein gültiges Dateiformat. Folgende Endungen sind möglich: {extensions}.",
            sizeError: "{file} ist zu groß zum Hochladen. Die maximale Größe beträgt {sizeLimit}.",
            minSizeError: "{file} die Datei ist zu klein. Sie muss mindestens {minSizeLimit} groß sein.",
            emptyError: "{file} ist leer.",
            noFilesError: "Keine Datein zum hochladen",
            tooManyItemsError: "Zu viele Datein ausgewählt ({netItems})",
            maxHeightImageError: "Das Bild ist zu groß.",
            maxWidthImageError: "Das Bild ist zu Breit.",
            minHeightImageError: "Das Bild ist nicht groß genug.",
            minWidthImageError: "Das Bild ist nicht breit genug.",
            retryFailTooManyItems: "Versuch fehlgeschlagen.",
            onLeave: "Die Datein werden hochgeladen. Wenn Sie die Seite verlassen, gehen Ihre Änderungen verloren!",
            unsupportedBrowserIos8Safari: "Ihr Browser unterstützt keine Dateiuploads."
        },
        callbacks: {
            onComplete: function(id, name, responseJSON, xhr){
                this.setName(id, responseJSON.file);
                
                var imageData = {'imageName': responseJSON.file, 'imagePath': responseJSON.path, 'imageIndex': id, 'imageID': responseJSON.image_id};
                
                var imageForm = $('<input>', {'type': 'hidden', 'name': 'image[' + id + ']', 'class': 'image-data', 'value': JSON.stringify(imageData), 'data-image-index': id});
                
                $('#app-example-form').append(imageForm);

                $('li[qq-file-id=' + id  + '] img.processed-image').attr('src', responseJSON.path);
                $('li[qq-file-id=' + id  + '] input.is_preview_image').val(id);
                
                if(!$('input.is_preview_image').is(':checked')){
                    $('li[qq-file-id=' + id  + '] input.is_preview_image').attr('checked', 'checked');
                }
            },
            onSessionRequestComplete: function(response, success){
                if(success){
                    $.each(response, function(index, image){
                        var imageData = {'imageName': image.name, 'imagePath': image.thumbnailUrl, 'imageIndex': index, 'imageID': image.image_id, 'cropper_canvas': $.parseJSON(image.cropper_canvas)};
                        var imageForm = $('<input>', {'type': 'hidden', 'name': 'image[' + index + ']', 'class': 'image-data', 'value': JSON.stringify(imageData), 'data-image-index': index});

                        $('#app-example-form').append(imageForm);

                        if (image.processedUrl == null) {
                            $('li[qq-file-id=' + index  + '] img.processed-image').attr('src', image.thumbnailUrl);
                        } else {
                            $('li[qq-file-id=' + index  + '] img.processed-image').attr('src', image.processedUrl);
                        }

                        $('li[qq-file-id=' + index  + '] input.imageDesc').val(image.image_title);
                        $('li[qq-file-id=' + index  + '] input.is_preview_image').val(index);
                        
                        if(image.is_preview == 1){
                            $('li[qq-file-id=' + index  + '] input.is_preview_image').attr('checked', 'checked');
                        }
                    });
                }
            },
            onSubmitDelete: function(id) {
                this.setDeleteFileParams({
                    file: this.getName(id),
                    _token: window.Laravel.csrfToken,
                    example_id: $('#example_id').val()
                }, id);
            },
            onDeleteComplete: function(id, xhr, isError) {
                if(!isError){
                    $('#app-example-form > input[data-image-index=\'' + id + '\']').remove();
                }
            }
        },
        deleteFile: {
            enabled: true,
            endpoint: '/de/ajax/examples/upload',
            params: {
                _token: window.Laravel.csrfToken,
                example_id: $('#example_id').val()
            }
        }
    });
    
    $(document).on('click', 'button.btn.edit-image', function() {
        var imageIndex = $(this).parents('li').attr('qq-file-id');
        var imageDataRAW = $('#app-example-form > input[data-image-index=\'' + imageIndex + '\']').val();
        var imageData = $.parseJSON(imageDataRAW);
        
        appendImageModal(imageData.imagePath, imageData.imageIndex, imageData.imageName);
    });
    
    $('button.btn.edit-image-account').on('click', function(e) {
        e.preventDefault();
        
        var $image = $(this).parents('div.row').find('img');
        
        appendImageModalAccount($image.data('original'));
    });
    
    $(document).on('shown.bs.modal', '.modal-image-edit', function() {
        $image = $('#exampleimage, #accountimage');
        
        if ($image) {
            $image.cropper({
                viewMode: 2,
                aspectRatio: $image.hasClass('accountimage') ? 1 / 1 : 4 / 3,
                minCropBoxWidth: $image.hasClass('accountimage') ? 300 : 800,
                dragMode: 'move',
                zoom: function(e){
                    var imageData = $image.cropper('getImageData');
                    var canvasData = $(this).cropper('getCanvasData');
                    var cropBoxData = $(this).cropper('getCropBoxData');
  
                    if ((imageData.width > imageData.naturalWidth || imageData.height > imageData.naturalHeight) && e.ratio > e.oldRatio) {
                        e.preventDefault();
                    }
                    
                    
                    if ((imageData.width < cropBoxData.width || imageData.height < cropBoxData.height) && e.ratio < e.oldRatio) {
                        e.preventDefault();
                    }
                },
                ready: function () {
                    if($image.hasClass('accountimage')) {
                        var imageDataRAW = $('#image_config').val();
                    } else {
                        var imageIndex = $('.modal-image-edit').data('image-index');
                        var imageDataRAW = $('#app-example-form > input[data-image-index=\'' + imageIndex + '\']').val();
                    }
                    
                    if(imageDataRAW != '') var imageData = $.parseJSON(imageDataRAW);
                    
                    if(typeof imageData != 'undefined' && !$.isEmptyObject(imageData.cropper_canvas)){
                        $image.cropper('setCropBoxData', imageData.cropper_canvas.cropBoxData);
                        $image.cropper('setCanvasData', imageData.cropper_canvas.canvasData);
                        $image.cropper('setImageData', imageData.cropper_canvas.imageData);
                        $image.cropper('setData', imageData.cropper_canvas.cropData);
                    }
                }
            });
        }
    });
    
    $(document).on('click', 'button.btn.rotate', function() {
        $image.cropper('rotate', 90);
    });
    
    $(document).on('click', 'button.btn.zoom-in', function() {
        $image.cropper('zoom', 0.1);
    });
    
    $(document).on('click', 'button.btn.zoom-out', function() {
        $image.cropper('zoom', -0.1);
    });

    $(document).on('click', 'button.btn.save-edit', function() {
        var tmpCroppedImage = $image.cropper('getCroppedCanvas', {maxWidth: 150}).toDataURL('image/jpeg', 1);
        var editedImageData = $image.cropper('getData', true);
        
        if($image.hasClass('accountimage')) {
            var imageDataRAW = $('#image_config').val();
            var imageData = $.parseJSON(imageDataRAW);

            imageData.crop_config = editedImageData;
            imageData.cropper_canvas = {
                cropBoxData: $image.cropper('getCropBoxData'),
                canvasData: $image.cropper('getCanvasData'),
                imageData: $image.cropper('getImageData'),
                cropData: $image.cropper('getData', true)
            };

            imageDataRAW = JSON.stringify(imageData);
            $('#image_config').val(imageDataRAW);
            
            if ($('#is_img_edit').length > 0) $('#is_img_edit').val('1');
            
            $('#image_config').parents('form').submit();
        } else {
            var imageIndex = $('.modal-image-edit').data('image-index');

            var imageDataRAW = $('#app-example-form > input[data-image-index=\'' + imageIndex + '\']').val();
            var imageData = $.parseJSON(imageDataRAW);

            imageData.example_id = $('#example_id').val();

            imageData.crop_config = editedImageData;
            imageData.cropper_canvas = {
                cropBoxData: $image.cropper('getCropBoxData'),
                canvasData: $image.cropper('getCanvasData'),
                imageData: $image.cropper('getImageData'),
                cropData: $image.cropper('getData', true)
            };

            imageDataRAW = JSON.stringify(imageData);
            $('#app-example-form > input[data-image-index=\'' + imageIndex + '\']').val(imageDataRAW);


            $('li[qq-file-id=' + imageIndex  + '] img.processed-image').attr('src', tmpCroppedImage);
        }

        $('.modal.in').modal('hide');
    });
});

function appendImageModal(source, id, imageName) {
    var image = $('<img/>', {'src': source, 'alt': '', 'class': 'img-responsive', 'id': 'exampleimage'});
    
    var modalContentOuter = $('<div>', {'class': 'modal modal-image-edit fade'});
    var modalContentWrapper = $('<div>', {'class': 'modal-dialog modal-lg'});
    var modalContentInner = $('<div>', {'class': 'modal-content'});
    var modalContentHeadline = $('<div>', {'class': 'modal-header'})
            .append($('<button>', {'type': 'button', 'class': 'close', 'html': '&times;', 'data-dismiss': 'modal'}));
    
    var modalContentFooter = $('<div>', {'class': 'modal-footer'})
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left rotate', 'html': $('<span>').append($('<i>', {'class': 'glyphicon glyphicon-repeat', 'style': 'padding-right: 10px;'})).append('90 &deg;')}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left zoom-in', 'html': $('<i>', {'class': 'glyphicon glyphicon-zoom-in'})}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left zoom-out', 'html': $('<i>', {'class': 'glyphicon glyphicon-zoom-out'})}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-default', 'data-dismiss': 'modal', 'text': 'Schließen'}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-success save-edit', 'text': 'Speichern'}))
    
    var modal = $(modalContentOuter)
            .append(modalContentWrapper
                .append(modalContentInner
                    .append(modalContentHeadline)
                    .append(image)
                    .append(modalContentFooter)
                )
            );
    
    $('.modal').not(modal).each(function(){
        $(this).modal('hide').remove();
    });     
    
    $(modal).attr('data-image-index', id).modal();
    $(modal).attr('data-image-name', imageName).modal();
}

function appendImageModalAccount(source) {
    var image = $('<img/>', {'src': source, 'alt': '', 'class': 'img-responsive accountimage', 'id': 'accountimage'});
    
    var modalContentOuter = $('<div>', {'class': 'modal modal-image-edit fade'});
    var modalContentWrapper = $('<div>', {'class': 'modal-dialog modal-lg'});
    var modalContentInner = $('<div>', {'class': 'modal-content'});
    var modalContentHeadline = $('<div>', {'class': 'modal-header'})
            .append($('<button>', {'type': 'button', 'class': 'close', 'html': '&times;', 'data-dismiss': 'modal'}));
    
    var modalContentFooter = $('<div>', {'class': 'modal-footer'})
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left rotate', 'html': $('<span>').append($('<i>', {'class': 'glyphicon glyphicon-repeat', 'style': 'padding-right: 10px;'})).append('90 &deg;')}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left zoom-in', 'html': $('<i>', {'class': 'glyphicon glyphicon-zoom-in'})}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-primary pull-left zoom-out', 'html': $('<i>', {'class': 'glyphicon glyphicon-zoom-out'})}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-default', 'data-dismiss': 'modal', 'text': 'Schließen'}))
            .append($('<button>', {'type': 'button', 'class': 'btn btn-success save-edit', 'text': 'Speichern'}))
    
    var modal = $(modalContentOuter)
            .append(modalContentWrapper
                .append(modalContentInner
                    .append(modalContentHeadline)
                    .append(image)
                    .append(modalContentFooter)
                )
            );
    
    $('.modal').not(modal).each(function(){
        $(this).modal('hide').remove();
    });     
    
    $(modal).modal();
}

function appendImageModalSlideshow(images, activeImage){
    activeImage = typeof activeImage !== 'undefined' ? activeImage : 0;
    
    var $carouselOuterWrapper = $('<div/>', {'id': 'carousel-appexample-images', 'data-ride': 'carousel', 'class': 'carousel slide'}),
        $carouselSlideWrapper = $('<div/>', {'class': 'carousel-inner', 'role': 'listbox'});
    
    $(images).each(function(index){
        var $image = $(this).clone().attr('class', ''),
            description = $(this).data('description'),
            $slideWrapper = $('<div/>', {'class': 'item'});
        
        if(index == activeImage){
            $slideWrapper.addClass('active');
        }
        
        if(typeof description !== 'undefined'){
            var carouselCaption = $('<h3/>', {'text': description}).wrap(
                    $('<div/>', {'class': 'carousel-caption'})
                ).parent();
        
            $slideWrapper.append(carouselCaption);
        }
        
        $slideWrapper.append($image);
        $carouselSlideWrapper.append($slideWrapper);
    });
    
    var $carouselControlLeft = $('<span/>', {'class' : 'glyphicon glyphicon-chevron-left', 'aria-hidden': 'true'}).wrap(
            $('<a/>', {'class': 'left carousel-control', 'href': '#carousel-appexample-images', 'data-slide': 'prev'})
        ).parent(),
        $carouselControlRight = $('<span/>', {'class' : 'glyphicon glyphicon-chevron-right', 'aria-hidden': 'true'}).wrap(
            $('<a/>', {'class': 'right carousel-control', 'href': '#carousel-appexample-images', 'data-slide': 'next'})
        ).parent(); 

    
    $carouselOuterWrapper.append([
        $carouselSlideWrapper,
        $carouselControlLeft,
        $carouselControlRight
    ]);
    
    var modalContentOuter = $('<div>', {'class': 'modal modal-image-edit fade'}),
        modalContentWrapper = $('<div>', {'class': 'modal-dialog modal-lg'}),
        modalContentInner = $('<div>', {'class': 'modal-content'}),
        modalContentBody = $('<div>', {'class': 'modal-body'}),
        modalContentHeadline = $('<div>', {'class': 'modal-header'})
                .append($('<button>', {'type': 'button', 'class': 'close', 'html': '&times;', 'data-dismiss': 'modal'}));
    
    var modal = $(modalContentOuter)
            .append(modalContentWrapper
                .append(modalContentInner
                    .append([
                        modalContentHeadline,
                        modalContentBody.append($carouselOuterWrapper)
                    ])
                )
            );
    
    $('.modal').not(modal).each(function(){
        $(this).modal('hide').remove();
    });     
    
    $(modal).modal().on('shown.bs.modal', function () {
        var $carousel = $(this).find('div.carousel.slide').carousel();
        
        if ($carousel.find('div.item').length <= 1){
            $carousel.find('.carousel-control, .carousel-indicators').hide();
        }
    });
}